<!--
  - Copyright (c) 2020 brightlamp
  -->

<template>
    <v-row justify="center">
        <v-dialog v-model="dialog" persistent max-width="400">
            <v-card >
                <v-card-title class="headline" style="color:#FFFD00;background-color:#363636;">Send Invite Email</v-card-title>
                <div class="ma-4">
                    Re-send the invite email to this org user?
                </div>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="cancel">Cancel</v-btn>
                    <v-btn color="blue darken-1" text @click="send" :loading="waiting" :disabled="waiting">Send</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import { mapState, mapActions, mapMutations } from 'vuex'

    export default
    {
        name: 'send-org-user-email-dialog',
        data: function ()
        {
            return {
                dialog: Boolean(true)
            }
        },
        computed:
        {
            ...mapState('common',
            {
                waiting: state => state.waiting
            })
        },
        props:
        {
            userData: {}
        },
        methods:
        {
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            ...mapActions('users', ['SEND_ORG_USER_EMAIL']),
            async send()
            {
                try
                {
                    this.HIDE_SNACKBAR();
                    this.WAITING(true);
                    await this.SEND_ORG_USER_EMAIL(this.userData.uId);
                    this.$emit('send-org-user-email-dialog-response')
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
                this.WAITING(false)
            },
            cancel()
            {
                this.$emit('send-org-user-email-dialog-response')
            }
        }
    };
</script>

<style scoped>
</style>